import SimplePage from './pages/view';

export const ProfileRoutes = [
  {
    path: '/perfil',
    component: SimplePage,
  },
];
